<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.66666 17C2.91174 17 2.42905 16.1955 2.78431 15.5294L9.11764 3.65441C9.49412 2.94853 10.5059 2.94853 10.8824 3.65441L17.2157 15.5294C17.5709 16.1955 17.0883 17 16.3333 17H3.66666ZM11 11V9C11 8.44772 10.5523 8 10 8C9.44771 8 9 8.44772 9 9V11C9 11.5523 9.44771 12 10 12C10.5523 12 11 11.5523 11 11ZM10 15C9.44771 15 9 14.5523 9 14C9 13.4477 9.44771 13 10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15Z"
  />
</svg>
